import PriceSectionLive from './PriceSectionLive';
import PriceSectionNew from './PriceSectionNew';

function PriceSection(props) {
  const { showNewPriceSection, isWrapperPdp } = props;
  return showNewPriceSection ? (
    <PriceSectionNew {...props} />
  ) : (
    <PriceSectionLive {...props} />
  );
}

export default PriceSection;
